module.exports = __webpack_public_path__ + "static/profile-5c439664b617a0288314c9014965343e.png";